module.exports = __webpack_public_path__ + "img/icon(12).d4c38a5f.png";